"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _routing = require("@engaging-tech/routing");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _components = require("@engaging-tech/components");
var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));
var MovedFlex = (0, _styledComponents["default"])(_components.Flex).withConfig({
  displayName: "OffAxisButton__MovedFlex",
  componentId: "sc-1gp3p7x-0"
})(["transform:translate(0px,25px);position:absolute;right:40px;"]);

/**
 * The button that appears just below the navbar.
 * @package
 */
var OffAxisButton = function OffAxisButton() {
  var _useNavContext = (0, _useNavContext2["default"])(),
    offAxisButtonRoute = _useNavContext.offAxisButtonRoute;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, offAxisButtonRoute && /*#__PURE__*/_react["default"].createElement(_routing.Link, (0, _extends2["default"])({
    to: offAxisButtonRoute.path
  }, offAxisButtonRoute.linkProps), /*#__PURE__*/_react["default"].createElement(MovedFlex, {
    width: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_components.Button, {
    key: offAxisButtonRoute.description,
    px: 3,
    color: "textPrimary.0",
    leadingIcon: offAxisButtonRoute.icon,
    borderRadius: 99,
    bg: "secondary.0",
    width: 240,
    height: 50,
    mr: "2vw"
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    color: "textPrimary.0",
    fontWeight: "700",
    fontFamily: "Centra",
    fontSize: 15,
    ml: -2
  }, offAxisButtonRoute.description)))));
};
var _default = exports["default"] = OffAxisButton;